import React from 'react';
import { DividerStyled } from './Divider.styled';

const Divider = ({children}) => {
    return <DividerStyled>
        {children}
    </DividerStyled> ;
};

export default Divider;